<template>
  <div>
    <div v-if="currentDocument" class="current-document">
      {{ filename(currentDocument) }}
    </div>
    <div v-if="template" class="current-document indent">
      <span v-if="capabilities.openDocumentTemplate"
        ><a :href="templateUrl" target="blank">{{ template.title }}</a>
        <span v-if="others">{{ others }}</span></span
      >
      <span v-else
        >{{ template.title }} <span v-if="others">{{ others }}</span></span
      >
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import currentTemplates from "@/mixins/currentTemplates";
import { filename } from "@/util/path";
import templates from "@/services/sharedo/templatesService";
import { openDocumentTemplate } from "@/util/urlBuilder";

const loadTemplate = async function() {
  try {
    this.logDebug("Loading template.", {
      systemName: this.currentTemplates[0],
    });

    this.template = await templates.getOne(this.currentTemplates[0]);
    this.logInfo("Loaded template.", this.template);
  } catch (error) {
    this.logError("Unable to load template.", {
      systemName: this.currentTempates[0],
      error,
    });
  }
};

export default {
  mixins: [currentTemplates],
  data: function() {
    return {
      template: null,
    };
  },
  computed: {
    ...mapState({
      currentDocument: (state) => state.currentDocument,
    }),
    others: function() {
      if (this.currentTemplates && this.currentTemplates.length > 1) {
        return `(+ ${this.currentTemplates.length - 1} other${
          this.currentTemplates.length > 2 ? "s" : ""
        })`;
      }

      return "";
    },
    templateUrl: function() {
      return openDocumentTemplate(this.template.systemName);
    },
  },
  watch: {
    currentTemplates: async function(newVal, oldVal) {
      const vm = this;
      if (
        newVal.length > 0 &&
        (oldVal.length === 0 || oldVal[0] !== newVal[0])
      ) {
        await vm.loadTemplate();
      } else if (newVal.length === 0) {
        vm.template = null;
      }
    },
  },
  methods: {
    filename,
    loadTemplate
  },
  mounted: async function() {
    if (this.currentTemplates && this.currentTemplates.length > 0) {
      await this.loadTemplate();
    }
  },
};
</script>
<style lang="scss" scoped>
.current-document {
  font-size: 0.85rem;
  font-weight: bold;

  &.indent {
    margin-left: 10px;
  }
}
</style>
